export default __webpack_public_path__ + "static/media/config.fe756f82.svg";